import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import AlphaLogo from "../../img/logo.png";

//  REDUX
import { useSelector } from "react-redux";
import ACTIONS from "../../actions/types";

// COMPONENTS
import Layout from "../layout/Layout";
import NewButton from "../buttons/NewButton";

// GLOBALS
import AA_GLOBAL from "../../globals/globals";
import GLOBALS from "../../globals";

// FUNCTIONS
import S from "../../functions/select";

const Footer = ({ addClass }) => {
  const selectedLang = useSelector(
    state => state.app.info.apps[state.app.info.default_app].chosen_locale
  );
  const languageList = useSelector(
    state => state.app.info.apps[state.app.info.default_app].locales
  );

  useEffect(() => {
    S("html")[0].setAttribute("lang", selectedLang.split("-")[0]);
  }, []);

  // const changeLanguage = newLocale => {
  //   AA_GLOBAL.cookies.set("lang", newLocale, { path: "/" });

  //   window.location.reload();
  // };

  const renderLangMenu = () => {
    const createMenuData = languageList.map(langName => ({
      langName,
      label: langName.split("-")[0].toUpperCase(),
      isChosen: langName === selectedLang,
    }));

    return (
      <div className="footer__lang">
        {createMenuData.map((item, i) => (
          <span key={item.langName}>
            {item.isChosen ? (
              <span style={{ cursor: "default" }} className="footer__lang-btnActive">
                {item.label}
              </span>
            ) : (
              <a href={`/lang?l=${item.label.toLowerCase()}`}>{item.label}</a>
            )}
            {i + 1 !== createMenuData.length && " | "}
          </span>
        ))}
      </div>
    );
  };

  const openCookiePolicy = () => {
    GLOBALS.reduxStore.dispatch({ type: ACTIONS.SHOW_COOKIE_PROMPTER });
  };

  return (
    <footer className={`bc12 ${addClass}`}>
      <Layout flex spaceBetween>
        <Layout flex>
          {renderLangMenu()}{" "}
        </Layout>
        <div>
          <a
            href="https://www.alpha-awards.com/"
            className="__fo_bl c16"
            data-test="AA_link"
            target="_black"
          >
            <span>
              <FormattedMessage id="powerdBy" />
            </span>
            <img src={AlphaLogo} alt="alpha awards" className="__fo_i" data-test="AA_logo" />
          </a>
        </div>
      </Layout>
    </footer>
  );
};

export default Footer;
